"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoxConfigurationStates = void 0;
exports.BoxConfigurationStates = {
    DRAFT: "DRAFT",
    FINALIZED: "FINALIZED",
    PACKAGES_GENERATED: "PACKAGES_GENERATED",
};
//# sourceMappingURL=box-configuration-states.js.map